import { LinearProgress } from "@mui/material";
import { useNavigation } from "react-router-dom";

export default function LoadingStateProgressBar() {
  const { state } = useNavigation();

  return <LinearProgress sx={{ opacity: state === "loading" ? 1 : 0 }} />;
}
